<template>
  <div class="c-media-block mb-10">
    <div class="relative h-0 pb-9/16">
      <template v-if="isMobile">
        <Picture
          v-if="image && image !== 'null'"
          v-bind="image"
          :mobile="[460, 345]"
          width="460"
          height="345"
          lazy
          img-class="absolute top-0 left-0 w-full h-full object-cover"
        />
        <img
          v-else
          class="absolute top-0 left-0 h-full object-cover"
          :src="`https://img.youtube.com/vi/${videoUrl}/hqdefault.jpg`"
          alt="youtube video thumbnail"
        >
        <div
          v-if="videoUrl"
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
        >
          <PlayButton :video-url="videoUrl" />
        </div>
      </template>
      <div
        v-else
        :style="`background-image: url(${image});`"
        class="c-media-block__container absolute top-0 left-0 w-full h-full bg-center bg-no-repeat bg-cover max-w-full"
      >
        <Picture
          v-if="image && image !== 'null'"
          v-bind="image"
          :mobile="[768, 432]"
          width="768"
          height="432"
          lazy
          img-class="absolute top-0 left-0 w-full h-full object-cover"
        />
        <template v-if="videoUrl">
          <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <button type="button"
                    class="lty-playbtn w-16 h-16 flex bg-blue-light items-center justify-center rounded-full shadow focus:outline-none focus:bg-blue-grey"
                    @click="playVideo"
            >
              <span class="icon-play" />
            </button>
          </div>
          <youtube-video
            :class="{'z-30 relative': isPlaying}"
            :video-id="videoUrl"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'
import PlayButton from '@/components/VideoOverlayTrigger.vue'
import YoutubeVideo from '@/components/YoutubeVideo.vue'
import EventBus from '../event-bus'

export default {
  components: {
    Picture,
    PlayButton,
    YoutubeVideo
  },
  props: {
    videoUrl: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      isMobile: window.matchMedia('(max-width: 639px)').matches,
      isPlaying: false
    }
  },
  methods: {
    playVideo() {
      this.isPlaying = true
      EventBus.$emit('PLAY_VIDEO')
    }
  }
}
</script>

<style>
  @media screen and (min-width: 800px) {
    .c-media-block {
      @apply max-w-860 w-860;
      position: relative;
    }

    [dir="ltr"] .c-media-block {
      left: 50%;
      transform: translateX(-50%);
    }

    [dir="rtl"] .c-media-block {
      right: 50%;
      transform: translateX(50%);
    }
  }
  .c-media-block > div {
    max-width: 100% !important;
  }
  .c-media-block__container {
    max-width: 100% !important;
  }
  .c-youtube-container {
    position: absolute;
    width: 100%;
    height: 100%;
    max-width: 100% !important;
    max-height: 100vh;
    top: 50%;
    transform: translateY(-50%);
  }
  .c-youtube-container iframe {
    width: 100%;
    height: 100%;
  }
  .c-visual-block-youtube .c-youtube-container {
    background: black;
    display: flex;
    align-items: center;
  }
  .c-visual-block-youtube .c-youtube-container iframe {
    aspect-ratio: 16/9;
    height: auto;
  }
</style>
